import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { useCheckout } from '../../hooks/useCheckout';

/**
 * SimulationBanner — discreet header shown across the app while
 * PAYMENTS_MODE=simulation is active. Lets the user and admin know
 * subscriptions activated here are not real charges.
 *
 * Dismissible per session via sessionStorage so it doesn't get in the
 * way after the user has acknowledged it.
 */
const SimulationBanner = () => {
  const { isSimulation, checking } = useCheckout();
  const [dismissed, setDismissed] = useState(
    typeof window !== 'undefined' && sessionStorage.getItem('onor_sim_banner_dismissed') === '1',
  );

  if (checking || !isSimulation || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('onor_sim_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      className="flex items-center gap-3 px-4 py-2 bg-amber-500/10 border-b border-amber-500/30"
      data-testid="simulation-banner"
    >
      <Sparkles className="w-4 h-4 text-amber-400 flex-shrink-0" />
      <p className="text-amber-200 text-xs flex-1">
        <strong>Modo simulación de pagos.</strong> Las suscripciones se activan sin cobrar — pruebas y QA.
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        className="text-amber-300/70 hover:text-amber-200 transition-colors"
        aria-label="Cerrar"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SimulationBanner;
